import { AxiosInstance } from "axios";
import axiosHelper from "../axiosHelper";
import ItemModel from "@/models/ItemModel";

export default class ItemsApiHelper {
	#url: string = '/api/items';
	#jwt: string;
	#searchItemsByPartNoHttpClient: AxiosInstance;

	constructor(jwt: string) {
		this.#jwt = jwt;
		this.#searchItemsByPartNoHttpClient = axiosHelper.createInstance(jwt);
	}

	async externalSearchItemsByPartNumber(partNumber: string): Promise<Array<ItemModel> | null> {
		try {
			const results = await this.#searchItemsByPartNoHttpClient.get(`${this.#url}/search/${partNumber}`);			
			const searchResults = results.data;
			if (!searchResults?.length) {				
				return [];
			}
			return searchResults.map((_: any) => new ItemModel(_));			
		} catch (e: any) {
			console.error(`Error searching items by partNumber '${partNumber}'`, e);
			return null;
		}
	}

	async findItemByPartNumberAndManufacturerName(number: string, manufacturerName: string) : Promise<ItemModel | null> {
		try {
			const findExistingItemHttpClient = axiosHelper.createInstance(this.#jwt);
			const findItemResponse = await findExistingItemHttpClient.get(`/api/items/search_existing/${number}/${manufacturerName}`);		
			return new ItemModel(findItemResponse.data);
		} catch(e: any) {
			if (e?.status === 404) {
				return null;
			}

			console.error('Unable to find item by PartNumber and ManufacturerName', e);
			return null;
		}
	}
}